import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IBaseResponse, IGetManyResponse } from '../../../utilities/http-utilities.service';
import { IEditIshikawaTemplate, IIshikawaTemplate, IIshikawaTemplateRequest } from './ishikawa-templates.interface';

@Injectable()
export class IshikawaTemplatesService {
  constructor(private readonly http: HttpClient) {}

  public getTemplates(params: HttpParams): Observable<IGetManyResponse<IIshikawaTemplate>> {
    return this.http.get<IGetManyResponse<IIshikawaTemplate>>('ishikawa-templates', { params });
  }

  public createTemplate(request: IIshikawaTemplateRequest): Observable<IBaseResponse<IIshikawaTemplate>> {
    return this.http.post<IBaseResponse<IIshikawaTemplate>>('ishikawa-templates', request);
  }

  public updateTemplate(editTemplate: IEditIshikawaTemplate): Observable<IBaseResponse<IIshikawaTemplate>> {
    return this.http.patch<IBaseResponse<IIshikawaTemplate>>(`ishikawa-templates/${editTemplate.id}`, editTemplate.dto);
  }

  public deleteTemplate(id: number): Observable<IBaseResponse<void>> {
    return this.http.delete<IBaseResponse<void>>(`ishikawa-templates/${id}`);
  }
}
